import {getTranslation} from "./helpers";
const bookingFirebaseIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
export const bookingRevisionConflictReasonCode = 'booking_revision_conflict';

export function isBookingFirebaseId(value) {
    return bookingFirebaseIdPattern.test(String(value || '').trim().toLowerCase());
}

export function createBookingMutationId() {
    return window.crypto.randomUUID().toLowerCase();
}

export function normalizeBookingIdentity(firebaseIdValue, revisionValue) {
    const firebaseId = String(firebaseIdValue || '').trim().toLowerCase();
    const expectedRevision = Number.parseInt(revisionValue, 10);

    // De to fejl var slået sammen til én besked, og ved et defekt id LØJ den:
    // brugeren fik "Invalid booking revision" om en booking hvis revision var
    // fuldstændig gyldig, og blev bedt om at genindlæse — hvilket ikke hjælper,
    // fordi id'et er forkert i datakilden. Det kostede en fejlsøgning 11. aug.
    // Teksterne var engelske. Jeg skrev dem selv 11. aug mens jeg rettede den
    // løgnagtige besked ovenfor, og de nåede en dansk skærm ordret.
    if (!isBookingFirebaseId(firebaseId)) {
        throw new Error(getTranslation('invalid_booking_reference'));
    }

    if (!Number.isInteger(expectedRevision) || expectedRevision <= 0) {
        throw new Error(getTranslation('invalid_booking_revision'));
    }

    return {
        firebase_id: firebaseId,
        expected_revision: expectedRevision,
    };
}

export function bookingIdentityFromElement(element) {
    return normalizeBookingIdentity(
        element.data('firebase-id') || element.attr('data-firebase-id'),
        element.data('revision') || element.attr('data-revision'),
    );
}

export function normalizeBookingReasonCode(value) {
    const reasonCode = String(value || '').trim().toLowerCase();
    return /^[a-z][a-z0-9_]{0,63}$/.test(reasonCode) ? reasonCode : '';
}

export function getBookingMutationError(response = null, fallbackMessage = getTranslation('generic_error')) {
    const payload = response?.data && typeof response.data === 'object'
        ? response.data
        : (response && typeof response === 'object' ? response : {});
    const message = typeof payload.message === 'string' && payload.message.trim()
        ? payload.message.trim()
        : fallbackMessage;

    return {
        message,
        reasonCode: normalizeBookingReasonCode(payload.reason_code || payload.reasonCode),
    };
}

export function isBookingRevisionConflict(error) {
    return error?.reasonCode === bookingRevisionConflictReasonCode;
}
